module.exports = __webpack_public_path__ + "img/asuka111-glitch.b780010.jpg";